export default __webpack_public_path__ + "c6d8ba67e2a6c710fb4e051900800373.svg";